import React, { Component } from 'react';
import { Table } from 'semantic-ui-react';
import { map, range } from 'ramda';
import Header from './Header.js';
import Row from './Row.js';
import { countries, counties, occupations } from '../../../../../../../common/utils/data';

class Members extends Component {
  constructor(props) {
    super();
  }

  render() {
    const { data, size, onChange } = this.props;

    return (
      <div className="rtxMembersTable">
        <Table basic>
          <Header />
          <Table.Body>
            {
              map((ix) =>
                  <Row
                    data={data[ix]}
                    key={'members_tbl_' + ix}
                    rowIx={ix}
                    onChange={onChange}
                    countries={countries}
                    counties={counties}
                    occupations={occupations}
                  />, range(0, size))
            }
          </Table.Body>
        </Table>
      </div>
    );
  }
}

export default Members;



// WEBPACK FOOTER //
// ./src/private/common/components/Team/Form/Team/Members/index.js